/* Parisvally: card add-to-cart — relocates the button into the card
   gallery and handles clicks. Global so it also covers cards inserted
   client-side (product recommendations etc.), where inline block scripts
   never execute. */
(function () {
  if (!window.pvCardAtcMove) {
    window.pvCardAtcMove = function () {
      document.querySelectorAll('.pv-card-atc:not([data-moved])').forEach(function (b) {
        var card = b.closest('.product-card') || b.closest('product-card');
        var gal = card && card.querySelector('[class*=card-gallery]');
        if (gal) { gal.appendChild(b); b.setAttribute('data-moved', '1'); }
      });
    };
    window.pvCardAtcMove();
    document.addEventListener('DOMContentLoaded', window.pvCardAtcMove);
    new MutationObserver(function () { window.pvCardAtcMove(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (window.pvCardAtcInit) return;
  window.pvCardAtcInit = 1;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pv-card-atc');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var t = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.dataset.variant, 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; window.location.href = '/cart'; })
      .catch(function () { b.disabled = false; b.textContent = t; });
  }, true);
})();
